import {
  RadiusOfOperationMiles,
  RecentVehicleLocations,
  MilesByState,
  MilesByZipcode,
  ActiveVehicles,
  MilesByMonth,
} from 'interfaces/ISummaryReport'
import request from 'tools/request'

export const summaryReportHeaderKpi = async (
  carrierId: string,
  carrierCode: string,
  codeValue: string,
  eldVendor: string
) => {
  const res = await request.get(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/${carrierId}/header-kpi?&carrierCode=${carrierCode}&codeValue=${codeValue}&eldVendor=${eldVendor}`
  )
  return res?.data
}

/* Radius of Operation */
export const getRecentVehicleLocations = async (
  carrierId: string,
  sinceHours?: number,
  size?: number,
  page?: number
): Promise<RecentVehicleLocations> => {
  const res = await request.get<RecentVehicleLocations>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/${carrierId}/recent-vehicle-locations`,
    {
      params: {
        sinceHours,
        size,
        page,
      },
    }
  )
  return res?.data
}

export const getMilesByState = async (
  carrierId: string,
  startDate: string,
  endDate: string
): Promise<MilesByState> => {
  const res = await request.get<MilesByState>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/${carrierId}/mileage/by-state`,
    {
      params: {
        startDate,
        endDate,
      },
    }
  )
  return res?.data
}

export const getMilesByZipcode = async (
  carrierId: string,
  startDate: string,
  endDate: string,
  size?: number,
  page?: number
): Promise<MilesByZipcode> => {
  const res = await request.get<MilesByZipcode>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/${carrierId}/mileage/by-zipcode`,
    {
      params: {
        startDate,
        endDate,
        size,
        page,
      },
    }
  )
  return res?.data
}

export const getRadiusOfOperationMileage = async (
  carrierId: string,
  startDate: string,
  endDate: string
): Promise<RadiusOfOperationMiles> => {
  const res = await request.get<RadiusOfOperationMiles>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/${carrierId}/mileage/by-radius`,
    {
      params: {
        startDate,
        endDate,
      },
    }
  )
  return res?.data
}

export const getActiveVehicles = async (
  carrierId: string,
  startDate: string,
  endDate: string
): Promise<ActiveVehicles> => {
  const res = await request.get<ActiveVehicles>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/${carrierId}/active-vehicles`,
    {
      params: {
        startDate,
        endDate,
      },
    }
  )
  return res?.data
}

export const getMilesByMonth = async (
  carrierId: string,
  startDate: string,
  endDate: string
): Promise<MilesByMonth> => {
  const res = await request.get<MilesByMonth>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}carriers/${carrierId}/mileage/by-month`,
    {
      params: {
        startDate, 
        endDate
      },
    }
  )
  return res?.data
}
